module.exports = __webpack_public_path__ + "static/media/Dev2grow.acd8df13.png";